<crm-tree-select
  class="block {{ styleClass }}"
  [options]="_directions"
  [(selectedItems)]="filteredDirections"
  (selectedItemsChange)="selectDirectionsHandler($event)"
  (panelShow)="panelShow.emit()"
  (panelHide)="panelHide.emit()"
  [label]="label"
  [groupsDisabled]="groupsDisabled"
  [placeholder]="placeholder"
  [scrollHeight]="scrollHeight"
  [sort]="sort"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [itemStyleClass]="itemStyleClass"
  [filtersUiVersion]="filtersUiVersion"
  [isFloatLabel]="isFloatLabel"
  [loading]="loading"
  selectionMode="checkbox"></crm-tree-select>
